import Handler from "../Handler";

class SendEmojiBroadcastHandler extends Handler {
  execute(data) {
    let receivedData = JSON.parse(data);
    this.service.processEmojiOnTable(receivedData);
  }
}

export default SendEmojiBroadcastHandler;
// sendEmojiB#{“playerName”:””,”tableId”:””,”emojiId”:””, ”statusCode”:200}
